'use client';

import { useEffect, useRef } from 'react';
import { initPolyfills } from './initPolyfills';

export const useInitPolyfills = () => {
  const didInit = useRef(false);
  useEffect(() => {
    if (!didInit.current) {
      initPolyfills();
      didInit.current = true;
    }
  }, []);
};
